<template>
  <div v-if="category">
    <app-header
      :title="(originalName)? 'Edit'+ originalName: 'New Media Category'"
      subtitle="Media Category"
    >
      <b-button variant="primary" @click="save()">
        Save Changes
      </b-button>
      <cancel-button />
    </app-header>
    <b-container>
      <b-row>
        <b-col>
          <b-form name="editorForm">
            <b-form-group>
              <label>Name</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input
                v-model="category.name"
                type="text"
                class="form-control"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <label>Thumbnail</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <FileInput v-model="category.thumbnail" required folder="mediacategories/thumbnail" />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import FileInput from '@/components/FileInput';
import CancelButton from '@/components/CancelButton';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    FileInput,
    CancelButton,
  },

  data() {
    return {
      originalName: null,
      category: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      if (this.$route.query.id) {
        $api.get(`/v1/internal/mediacategories/${this.$route.query.id}`).then((category) => {
          this.originalName = category.name;
          this.category = category;
        });
      } else {
        this.category = {};
      }
    },

    async save() {
      let category;
      if (this.category.id) {
        category = await $api.put(`/v1/internal/mediacategories/${this.category.id}`, this.category);
      } else {
        category = await $api.post('/v1/internal/mediacategories', this.category);
      }
      this.$router.push({
        name: 'mediacategory-detail',
        params: category,
      });
    },
  },
};
</script>
